import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

/**
 * Persists sidebar collapsed state to localStorage under "sidebar_collapsed".
 * atomWithStorage handles both reading from and writing to storage automatically.
 */
export const sidebarCollapsedAtom = atomWithStorage<boolean>(
  "sidebar_collapsed",
  false,
);

/** Admin panel sidebar collapsed state — persisted separately from dispatcher. */
export const adminSidebarCollapsedAtom = atomWithStorage<boolean>(
  "admin_sidebar_collapsed",
  false,
);

/** Dealer panel sidebar collapsed state — persisted separately. */
export const dealerSidebarCollapsedAtom = atomWithStorage<boolean>(
  "dealer_sidebar_collapsed",
  false,
);

/**
 * Mobile sidebar open state — not persisted (resets on page load).
 * On mobile (<lg), the sidebar is hidden by default and toggled via hamburger.
 */
export const sidebarMobileOpenAtom = atom<boolean>(false);
